export default {

    computed: {

		_trocaEquipamentoAeronave(){
			return $cliente.get('troca_equipamento_aeronave') == '1'
		},

		_atualizaOrigemDestino(){
			return $cliente.get('atualiza_dados_fdm') == '1'
		},

		_versaoSistema(){
            return $cliente.getVersao('versao')
		},

		_img1(){
			return  $cliente.get('link_app') +'/clientes/' + $cliente.get('nome_pasta') + "/" +  $cliente.getVersao('img1') + "?" + this._getVersao()
		},

		_aisp(){
			return  $cliente.get('link_app') +'/clientes/' + $cliente.get('nome_pasta') + "/aisp.json"
		},

		_img2(){
			return  $cliente.get('link_app') +'/clientes/' + $cliente.get('nome_pasta') + "/" +  $cliente.getVersao('img2') + "?" + this._getVersao()
		},

		_titulo(){
			return $cliente.getVersao('titulo_inicio')
		},

		_subtitulo(){
			return $cliente.getVersao('subtitulo_inicio')
		},

		_fusoHorario(){
			// return moment().tz("America/Los_Angeles").format()
			return new moment().tz($cliente.get("fuso_horario")).format('Z')
		},

		_idCliente(){
			return $cliente.get('id')
		},

		_height(){
			return window.innerHeight;
		},

		_width(){
			return window.innerWidth;
		},
    },

    methods: {

		_exibeAeroOrgao(aeronave){
			// TODO criar uma config para isso
			if(aeronave.id_orgao_operador == window.$sessao.getIdOrgao()){
				return true
			} else {
				if(!_.isNil(aeronave.orgao)){
					for(let i in aeronave.orgao){
						if(aeronave.orgao[i].id_orgao == window.$sessao.getIdOrgao()){
							return true
						}
					}
				}
			}

			return false
		},

		_getImageGoogle(tamanho_icone, url){

			if(_.isNil(tamanho_icone)){
				tamanho_icone = 1
			} else {
				tamanho_icone = Number(tamanho_icone)
			}

			let imageSizes = {
				size: [59.6, 54.3],
				anchor: [29.8, 27.15],
				scaledSize: [59.6, 54.3],
			}

			return {
				url: url,
				size: new google.maps.Size(imageSizes.size[0] * tamanho_icone, imageSizes.size[1] * tamanho_icone),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(imageSizes.anchor[0] * tamanho_icone, imageSizes.anchor[1] * tamanho_icone),
				scaledSize: new google.maps.Size(imageSizes.scaledSize[0] * tamanho_icone, imageSizes.scaledSize[1] * tamanho_icone)
			}
		},

		_getLinkImage(tipo, movimento, direcao, cor, stopIconPNG, icone){

			if(_.isNil(icone)){
				icone = '1'
			}

			let iconStop = 'svg'
			if(stopIconPNG){
				iconStop = 'png'
			}

			// se for a vale e tiver voando coloca a cor verde
			if(movimento == 'Y' && this._idCliente == 25){
				cor = 'verde'
			}

			// var urlbase =  $cliente.get('link_app') +'/clientes/icones/'
			var urlbase = 'https://services.followair.com.br/icones/'

			// aviao
			if(tipo == 'A'){
				urlbase += `a/${icone}/`

				if(movimento == "Y"){
					urlbase += `${cor}/fly/${direcao}.svg?v=${this._getVersao()}`
				} else {
					urlbase += `${cor}/stop/${direcao}.${iconStop}?v=${this._getVersao()}`
				}
			}

			// helicoptero
			if(tipo == 'H'){
				urlbase += `h/${icone}/`

				if(movimento == "Y"){
					urlbase +=  `${cor}/fly/${direcao}.svg?v=${this._getVersao()}`
				} else {
					urlbase += `${cor}/stop/${direcao}.${iconStop}?v=${this._getVersao()}`
				}
			}

			return urlbase;
        },

		_getPin(cor){
			return $cliente.get('link_app') +'/clientes/icones/pins/' + cor + '.png'
		},

		_carregaCliente(){
			var self = this

			$.getJSON(window.location.href.split("#")[0] + 'config.json?' + this._getVersao(), function(retorno){
                ////console.log(retorno)
                $config.set(retorno)

                self._carregaWSCliente() // chama o ws para carregar o cliente
                self._carregaClienteLoop() // função que fica verificando se já carregou o cliente

            }).fail(function() { console.log("Não foi possivel encontrar os dados do cliente."); })
		},

		_carregaWSCliente(){
			this._httpGet('/Cliente/get_cliente', function(retorno){
				if(retorno._request){
					retorno.cliente._update = false
					$cliente.set(retorno.cliente)
				}
			})
		},

		_carregaClienteLoop(){
			var self = this

			if($cliente.get('id') == null){
				setTimeout(function (){
					self._carregaClienteLoop()
				}, 3000)
			} else {
				if($cliente.get('_update') == false){
					var cliente = $cliente.get()

					cliente._update = true
					$cliente.set(cliente)
					//console.log("akiii")
					bus.$emit('cliente-carregado', cliente)
					//location.reload();
				}
			}
		},

		_carregaContatos(callback, login){

			this._httpGet('Usuario/get_dados_usuario/' + login, function(retorno){
				if(retorno._request && retorno._status){
					callback(retorno.usuario)
				} else if(!retorno._status){
					callback(false)
				}
			})
		},

		_validaSenhaMestre(callback, senha){

			var data = {
				senha: senha
			}

            var self = this
            jQuery.ajax({
                type: 'POST',
                headers: { 'Authorization':this.getToken() },
                url: this.getURL_WS('/Usuario/valida_senha_mestre'),
                data: { "data": JSON.stringify(data) },
                dataType: 'json',
                success: function (retorno){

					if(retorno.status == 'true'){
						callback(true)
					} else {
						callback(false)
					}


                },
                error: function (e) {
					callback(false)
                    self.exibirLoad = false
                    //console.log(e);
                    bus.$emit('modal-erro-show',e);
                }
            });
		},

    }
}